import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import PracticalExerciseWrapper from './PracticalExerciseWrapper';
import PracticalExerciseInstructions from './PracticalExerciseInstructions';
import PracticalExerciseStartButton from './PracticalExerciseStartButton';
import { ExerciseAssetTypename } from '../../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isChirpExercise = content => '__typename' in content && content.__typename === ExerciseAssetTypename;
const NotStartedPracticalExercise = ({
  advanceToNextContent,
  exercise,
  exerciseLocation,
  onStartClick,
  contentId,
  lessonId,
  trackId,
  language,
  isSimulationExercise
}) => {
  const isManuallyApproved = exercise && isChirpExercise(exercise) ? exercise.manuallyApproved : false;
  const renderButtons = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "skip-nonstarted-practical-exercise",
        marginInlineEnd: "300",
        onClick: advanceToNextContent,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.skip"
        })
      }), /*#__PURE__*/_jsx(PracticalExerciseStartButton, {
        contentId: contentId,
        exerciseLocation: exerciseLocation,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.startExercise"
        }),
        language: language,
        lessonId: lessonId,
        onStartClick: onStartClick,
        trackId: trackId,
        use: "primary"
      })]
    });
  };
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "not-started-practical-exercise",
    children: /*#__PURE__*/_jsx(PracticalExerciseWrapper, {
      buttons: renderButtons(),
      isStarted: false,
      children: /*#__PURE__*/_jsx(PracticalExerciseInstructions, {
        description: exercise.description,
        isGraded: !!exercise.graded,
        isManuallyApproved: isManuallyApproved,
        isSimulation: isSimulationExercise,
        name: exercise.name
      })
    })
  });
};
export default NotStartedPracticalExercise;